import {
  CHARGES_LIST_REQUEST,
  CHARGES_LIST_SUCCESS,
  CHARGES_LIST_ERROR,
  CHARGES_LIST_RESET,
} from "./ActionType";

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

const chargesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHARGES_LIST_REQUEST:
      return { ...initialState, isRequest: true };
    case CHARGES_LIST_SUCCESS:
      return { ...initialState, isSuccess: true, data: action.payload };
    case CHARGES_LIST_ERROR:
      return { ...initialState, isError: true, error: action.payload };
    case CHARGES_LIST_RESET:
      return initialState;
    default:
      return state;
  }
};

export default chargesReducer;
